import styles from './Header.module.css';
import { useNavigate } from "react-router-dom";
import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { AuthContext } from "../../utils/contextapi/AuthProvider";
import { ModalContext } from "../../utils/modal/ModalProvider";
import moment from "moment/moment";
import { useQuery } from "@tanstack/react-query";
import axios from "../../utils/api/axios";
import { CLIENT_SECRET, CLIENT_ID } from "../../utils/Config";
import { DialogEnum, showDialog } from "../../utils/dialog/Dialog";
import { } from '../../utils/token/token';
import ServiceSelector from './component/ServiceSelector';
import { InnocodeButton } from '@intsoft/innocode-core'; 

const getPlatform = () => {
    if (window.innerWidth < 768) return 'mobile';
    if (window.innerWidth < 1440) return 'tablet-vertical';
    return 'web';
};

/**
 * 관리도구 Header Container
 * @returns {JSX.Element}
 * @constructor
 */
function Header({ setIsMobileMenuOpen, user, tokenExpiredTime, sessionLogout, viewMode, enableGobackBar = 'false' }) {

    const movePage = useNavigate();

    const { minute, second } = tokenExpiredTime;

    //화면 크기를 감지하는 상태 추가
    const [platform, setPlatform] = useState(getPlatform);
    const visiblePlatforms = ['mobile', 'tablet-vertical'];

    useEffect(() => {
        if (window.requestConnetxa) {
            window.requestConnetxa.setClientSecret(CLIENT_SECRET);
            window.requestConnetxa.setClientId(CLIENT_ID);
        }

        // 초기 사이즈 설정 
        setPlatform(getPlatform(window.innerWidth));
        // 윈도우 리사이즈 이벤트 핸들러
        const handleResize = () => {
            setPlatform(getPlatform(window.innerWidth));
        };

        window.addEventListener('resize', handleResize);

        // 클린업 함수
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onClickMain = () => {
        movePage('/account/manage');
    }

    const isMobileOrTablet = visiblePlatforms.includes(platform);

    return (
        <section className={styles.rightCont__header}>
            <div className={styles.rightCont__header__mark} >
                {/* ✅ 모바일일 때 "더보기" 아이콘 표시 */}
                {/* {(
                    enableGobackBar === 'true' &&
                    <header className="mobile-header">
                        <InnocodeButton onClick={() => { window.history.back() }} designType={'assistive'} theme={'opacity'} iconOnly={true} icon={
                            <svg className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
                            </svg>
                        }></InnocodeButton>
                    </header>
                )} */}

                {isMobileOrTablet && (
                    <>
                        {(
                            enableGobackBar === 'true' &&
                            <header className="mobile-header">
                                <InnocodeButton onClick={() => { window.history.back() }} designType={'assistive'} theme={'opacity'} iconOnly={true} icon={
                                    <svg className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
                                    </svg>
                                }></InnocodeButton>
                            </header>
                        )}
                        <div className={styles.rightCont__header__logo} onClick={onClickMain} />
                        {/* <p className={styles.rightCont__header__name}>Zentry</p> */}
                    </>
                )}
                


            </div>

            <div className={styles.rightCont__header__user}>
             {viewMode === 'service_only' && <ServiceSelector />}
                {isMobileOrTablet&& (
                    // 모바일 또는 태블릿일 때의 UI (햄버거 메뉴)
                    <button className={styles.mobileMenuToggleBtn} onClick={() => setIsMobileMenuOpen(true)}>
                        <span className="material-symbols-outlined">menu</span>
                    </button>
                )}
            </div>
        </section>
    )
}

export default Header;